import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { withStyles } from '@material-ui/core/styles';

class CardForm extends Component {
  state = {
    forbiddenError: false,
    emailError: false,
  };



  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ forbiddenError: false, emailError: false });
    try {
      await this.props.onSubmit();
    } catch (err) {
      console.error(err);
      if (err.status === 409) {
        this.setState({ forbiddenError: false, emailError: true });
      } else {
        this.setState({ forbiddenError: true, emailError: false });
      }
      window.scrollTo(0, 0);
    }
  };

  render() {
    const { forbiddenError, emailError } = this.state;
    const {
      children,
      classes,
      headerText,
      headerSubText,
      submitText,
      widthOverride,
      errorText,
      buttonDisable
    } = this.props;
    const styleOverride = widthOverride && { width: widthOverride };
    const emailErrorText =
      'The email you entered is already in use. Please try again.';

    return (
      <div className={classes.root}>
        {forbiddenError && (
          <div className={classes.error} style={styleOverride}>
            <span>{errorText}</span>
          </div>
        )}
        {emailError && (
          <div className={classes.error} style={styleOverride}>
            <span>{emailErrorText}</span>
          </div>
        )}

        <Grid
          container
          spacing={0}
          classes={{ container: classes.container }}
          style={styleOverride}
        >
          <header className={classes.header}>
            <h1 className={classes.giantHeader}>{headerText}</h1>
            {headerSubText && <span>{headerSubText}</span>}
          </header>

          <ValidatorForm
            ref="form"
            instantValidate={false}
            onSubmit={this.handleSubmit}
            className={classes.form}
          >
            <Grid container spacing={8}>
              {children}

              <div className={classes.actions}>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  type="submit"
                  className={classes.submitButton}
                  disabled = {buttonDisable ? buttonDisable :false}
                >
                  {submitText}
                </Button>
              </div>
            </Grid>
          </ValidatorForm>
        </Grid>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '65px',
    marginBottom: '35px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '35px',
    },
  },
  error: {
    width: '35%',
    backgroundColor: '#FFF6BF',
    marginBottom: '10px',
    color: 'grey',
    padding: '1rem',
    textAlign: 'center',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
    [theme.breakpoints.down('lg')]: {
      width: '45%',
    },
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  container: {
    width: '30%',
    backgroundColor: 'white',
    padding: '2rem',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
    [theme.breakpoints.down('lg')]: {
      width: '45%',
    },
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  form: {
    width: '100%',
  },
  header: {
    color: '#505D68',
    lineHeight: '44px',
    marginBottom: '20px',
  },
  giantHeader: {
    fontSize: '2em',
    fontWeight: 'bold',
  },
  actions: {
    width: '100%',
    textAlign: 'right',
    marginTop: '20px',
  },
  submitButton: {
    color: 'white',
  },
});

export default withStyles(styles)(CardForm);
